module.exports = __webpack_public_path__ + "static/img/live_tu22.da5b777.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/live_tu22.png
// module id = P51A
// module chunks = 1